/** @returns {HTMLElement | null} */
const firstDataGridRow = () =>
  document.querySelector('#home .MuiDataGrid-row[data-rowindex="0"]') ||
  document.querySelector('#home .MuiDataGrid-row');

/** @returns {HTMLElement | null} */
const firstTownResponseCell = () => {
  const row = firstDataGridRow();
  if (!row) return null;
  return row.querySelector('.MuiDataGrid-cell[data-field="TownResponse"]');
};

/** @returns {HTMLElement | null} */
const firstTownCounterCell = () => {
  const row = firstDataGridRow();
  if (!row) return null;
  return (
    row.querySelector('.MuiDataGrid-cell[data-field="TownOffer"]')
  );
};

/** @returns {HTMLElement | null} */
const firstTownNotesCell = () => {
  const row = firstDataGridRow();
  if (!row) return null;
  return row.querySelector('.MuiDataGrid-cell[data-field="TownNotes"]');
};

/** @returns {HTMLElement | null} */
const firstProprietyWorkupCell = () => {
  const row = firstDataGridRow();
  if (!row) return null;
  return row.querySelector('.MuiDataGrid-cell[data-field="ProprietyWorkup"]');
};

/** @returns {HTMLElement | null} */
const firstWorkupDocIcon = () => {
  const cell = firstProprietyWorkupCell();
  if (!cell) return null;
  return (
    cell.querySelector('[data-town-tutorial="workup-doc-icon"]') ||
    cell.querySelector('.MuiIconButton-root') ||
    null
  );
};

const WORKUP_STEP = {
  title: 'Aventine workup',
  body: "Here you can see Aventine's workup value. Click the document icon to view the evidence itself.",
  resolveTarget: firstProprietyWorkupCell,
  resolveIconTarget: firstWorkupDocIcon,
  padding: 4,
  borderRadius: 6,
  iconPadding: 3,
  iconBorderRadius: 20,
};

const BASE_TOWN_VIEW_TUTORIAL_STEPS = [
  {
    title: 'Your cases',
    body: 'Each row is a property in your municipality for this tax year.',
    resolveTarget: firstDataGridRow,
    padding: 4,
    borderRadius: 6,
  },
  {
    title: 'Case overview',
    body: 'These counts show the total cases, the SCAR or BAR cases, Article 7 when any exist, and how many are already settled.',
    resolveTarget: () => document.querySelector('[data-town-tutorial="stats"]'),
    padding: 10,
    borderRadius: 12,
  },
  {
    title: 'Town Response',
    body: 'Use Accept or Counter to respond to offers. Settled cases show their status here; recently accepted settlements can be cancelled.',
    resolveTarget: firstTownResponseCell,
    padding: 8,
    borderRadius: 8,
  },
  {
    title: 'Town Counter',
    body: 'Here, counter offers can be entered. By default, it expects a market value in dollars.',
    resolveTarget: firstTownCounterCell,
    paddingX: 6,
    paddingY: 4,
    borderRadius: 8,
  },
  {
    title: 'Town Notes',
    body: 'If you have specific notes to include, you can add them here once you have made an offer. To see your notes from prior rounds, download the spreadsheet.',
    resolveTarget: firstTownNotesCell,
    padding: 8,
    borderRadius: 8,
  },
  {
    title: 'Filters',
    body: 'Add or remove columns from the table, filter by a specific court date or settlement status, or quickly search for any information in the table.',
    resolveTarget: () => document.querySelector('[data-town-tutorial="toolbar-filters"]'),
    padding: 8,
    borderRadius: 8,
  },
  {
    title: 'Toolbar',
    body: 'Here, you can toggle Assessed Value (AV) mode if you would prefer to see and enter values in assessment units. Actions lets you flag an issue on selected cases, download stipulations on settled cases, and upload countersigned stipulations.',
    resolveTarget: () => document.querySelector('[data-town-tutorial="toolbar-actions"]'),
    padding: 8,
    borderRadius: 8,
  },
  {
    title: 'Replay tutorial',
    body: 'As new features are released, if you ever want to re-watch the tutorial, you can do so by clicking here.',
    resolveTarget: () => document.querySelector('[data-town-tutorial="replay"]'),
    padding: 4,
    borderRadius: 6,
  },
];

/** @param {{ shareWorkups?: boolean }} [options] */
export const buildTownViewTutorialSteps = ({ shareWorkups = false } = {}) => {
  if (!shareWorkups) return BASE_TOWN_VIEW_TUTORIAL_STEPS;

  const steps = [...BASE_TOWN_VIEW_TUTORIAL_STEPS];
  const filtersIndex = steps.findIndex((s) => s.title === 'Filters');
  steps.splice(filtersIndex, 0, WORKUP_STEP);
  return steps;
};
